/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
/* eslint-disable no-lonely-if */
import React from 'react';
import { Container, Grid, Box, Typography, Button, Paper, Link, Divider, Card } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import posthog from 'posthog-js';
import helper from '../../../utils/helper';
import trialAndStripeSubscriptionService from '../../../services/trialAndStripeSubscriptionService';
import { openSnackbar } from '../../../store/reducer';
import ComingSoonImage from '../../../assets/Images/coming-soon-art.svg'
 
 
const CheckoutPage = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const allassessmentdetails = useSelector((state) => state);
    const userid = useSelector((state) => state.userInfo && state.userInfo.id);
    const [currency, setCurrency] = React.useState(allassessmentdetails?.userInfo?.currencyType ? allassessmentdetails?.userInfo?.currencyType.code : 'USD');
 
    const COLORS = {
        grey: '#7A7A7A',
        discountBg: '#F7E9ED',
        discountText: '#B3254D',
        includedBg: '#E9EFFD',
        includedText: '#252525',
        primary: '#2563EB'
    };
 
    const IMPORTANT_DETAILS = [
        { title: 'Access', detail: 'Begins immediately after successful payment until the next validity' },
        { title: 'Refund policy', detail: 'Non-refundable even after immediate cancellation' },
        { title: 'Platforms', detail: 'Accessible on desktop or tablet or mobile' },
        { title: 'Auto Renewal', detail: 'The auto renewal is turned on by default. You may turn it off on the Stripe page' },
        { title: 'Accessibility', detail: 'Any purchase on keySkillset is accessible only online and nothing offline' }
    ];
 
    const INCLUDED_ITEMS = [
        '5 test attempts with diagnostic analysis',
        '1200+ questions across all attempts',
        'Bi-weekly study materials sent to your email',
        '24/7 access to all solutions and analysis till validity'
    ];
 
 
    const postAssessmentSubscribtionDetails = async () => {
 
        const courseId = location.state?.id;
        const planid = location.state?.subscriptionplanid || location.state?.subscriptionPlanId;
 
        let impactClickId = '';
        try {
            impactClickId = await helper.getClickId();
        } catch (error) {
            console.error(error);
            impactClickId = '';
        }
 
        const payload = {
            userId: userid,
            courseId,
            planId: planid,
            currencyType: currency,
            // eslint-disable-next-line radix
            frequency: parseInt(1),
            impactClickId,
            type: 'assessment'
        };
 
        try {
            const res = await trialAndStripeSubscriptionService.createAssessmentSubscription(JSON.stringify(payload));
 
            if (res.status === 303) {

                posthog.capture('subscription_payment_initiated', {
                    plan_id: location.state?.subscriptionplanid || location.state?.subscriptionPlanId,
                    course_id: location.state?.id,
                    currency,
                });
                window.location = res.data.paymentUrl;
            } else {
                if (res?.data?.message) {
                    dispatch(openSnackbar(res.data.message));
                } else {
                    dispatch(openSnackbar('Failed to Subscribe, Please try again.'));
                }
            }
        } catch (error) {
            console.log(error);
        }
 
    };
    console.log(location.state, "location.state");
 
 
 
    const handleStartSat = () => {
        if (location.state?.type === 'Chapter') {
            const c = location.state?.chapter_code?.toLowerCase().includes("eng");
            if (c === true) {
                navigate("/auth/ChapterLevelSimulation", {
                    state: {
                        subject: "English",
                        chapterid: location.state?.chapter_id
                    }
                });
            }
            else {
                navigate("/auth/ChapterLevelSimulation", {
                    state: {
                        subject: "Maths",
                        chapterid: location.state?.chapter_id
                    }
                });
            }
 
        }
        else {
 
            navigate(`/auth/assessment/${encodeURIComponent(location?.state?.title)}/${location.state?.id}`, {
                state: {
                    id: location.state?.id,
                    from: "SAT",
                    data: location.state
                }
            });
        }
    }
 
    const handleStartSatGoBack = () => {
        if (location.state?.type === 'Chapter') {
            navigate('/auth/ChapterLevelSimulation', { state: { chapterid: location.state?.chapter_id } });
        }
        else {
            navigate(`/auth/assessment/${encodeURIComponent(location?.state?.title)}/${location.state?.id}`, {
                state: {
                    id: location.state?.id,
                    from: "SAT",
                    data: location.state
                }
            });
        }
    }
 
 
 
 
    const ComingSoon = () => {
        return (
            <Container
                maxWidth="sm"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "100vh",
                    textAlign: "center",
                    backgroundColor: "#f8f9fa",
                }}
            >
                <Card
                    sx={{
                        p: 3,
                        mt: 7,
                        width: '100%',
                        borderRadius: 4,
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
 
                    <Box
                        sx={{
                            position: "relative",
                            display: "inline-block",
 
                            textAlign: "center",
                        }}
                    >
                        <Box>
                            <img
                                src={ComingSoonImage}
                                alt="Coming Soon"
                                style={{ width: "350px", height: "auto" }}
                            />
                        </Box>
 
 
                    </Box>
 
 
                    <Typography
                        variant="body1"
                        sx={{
                            mt: 10,
                            mb: 4,
                            color: "gray",
                            fontSize: "1rem",
                            lineHeight: 1.6,
                            px: 2,
                        }}
                    >
                        The <b style={{ font: 'bold' }}>{location?.state?.chapter_description}</b> is under the making
                        right now. You will be the first one to be notified. Thank you for
                        your patience!
                    </Typography>
 
                    <Button
                        startIcon={<ArrowBackIcon />}
                        variant="outlined"
                        color="inherit"
                        sx={{
                            textTransform: "none",
                            borderRadius: "8px",
                            px: 3,
                            py: 1,
                            fontWeight: 500,
                            borderColor: "#ccc",
                            color: "#444",
                            backgroundColor: "transparent",
                            "&:hover": {
                                borderColor: "#999",
                                backgroundColor: "#f5f5f5",
                            },
                        }}
                        onClick={handleStartSat}
                    >
                        Go Back
                    </Button>
                </Card>
            </Container>
 
        );
    }
 
    const Prepayment = () => {
        return <Container maxWidth="lg" sx={{ py: { xs: 2, sm: 4 }, marginTop: '50px' }}>
            <Box sx={{ mb: 2 }}>
                <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={handleStartSatGoBack}
                    sx={{ color: COLORS.grey, borderColor: COLORS.grey, '&:hover': { borderColor: COLORS.grey, bgcolor: 'rgba(122, 122, 122, 0.04)' }, borderRadius: '8px', padding: '8px 16px' }}>
                    Back
                </Button>
            </Box>
 
            <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', fontSize: { xs: '1rem', sm: '1.8rem' } }}>
                Checkout
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ fontSize: '12px !important', mb: 2, ml: '4px' }}>
                Know about your plan before completing your purchase and before redirecting to Stripe
            </Typography>
 
            <Grid container spacing={4}>
                <Grid item xs={12} md={7.25}>
                    <Paper elevation={0} sx={{ p: { lg: 2.5, md: 2, sm: 2, xs: 1.5 }, fontSize: '12px', height: '100%', border: '1px solid #e0e0e0', borderRadius: 2 }}>
                        <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', mb: 2 }}>
                            Important Details
                        </Typography>
                        <Typography variant="body2" sx={{ mb: 3, fontSize: '12px', lineHeight: 1.6 }}>
                            Please read through the important instructions before proceeding to pay. These are important to your journey with us and our growth with you.
                        </Typography>
 
                        <Box component="ul" sx={{ listStyleType: 'disc', listStylePosition: 'inside', pl: 2, mb: 3, fontSize: '12px', lineHeight: 1.6, color: COLORS.includedText }}>
                            {IMPORTANT_DETAILS.map((item, index) => (
                                <Box key={index} component="li" sx={{ mb: 0.5 }}>
                                    <Box component="span" sx={{ fontWeight: 'bold' }}>{item.title}:</Box> {item.detail}
                                </Box>
                            ))}
                        </Box>
 
                        <Typography variant="body2" sx={{ fontSize: '12px' }}>
                            After you click "Pay Now", you will be redirected to Stripe to complete payment securely through Stripe.
                        </Typography>
 
                        <Typography variant="body2" sx={{ mt: 1, pt: 1, fontSize: '12px' }}>
                            Options or decisions clicked on the Stripe page is your responsibility and we are unable to help you there.
                        </Typography>
 
                        <Typography variant="body2" sx={{ mt: 1, pt: 1, fontSize: '12px' }}>
                            Need help? Write us to
                            <Link href="mailto:contact@keyskitset.com" sx={{ ml: 1, color: '#2563EB', textDecorationColor: '#2563EB', '&:hover': { color: '#1E40AF', textDecorationColor: '#1E40AF' } }}>contact@keyskitset.com</Link>
                        </Typography>
                    </Paper>
                </Grid>
 
                <Grid item xs={12} md={4.75}>
                    <Paper elevation={0} sx={{ borderRadius: 2, height: '100%', border: '1px solid #e0e0e0', p: { lg: 2.5, md: 2, sm: 2, xs: 1.5 } }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                            <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold' }}>Review Your Order</Typography>
                            <Box sx={{ bgcolor: COLORS.discountBg, color: COLORS.discountText, borderRadius: '18px', fontSize: '0.71rem', fontWeight: 'bold', mt: 0.5, width: '80px', height: '22px', padding: '5px 0', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                60% OFF
                            </Box>
                        </Box>
                        <Divider sx={{ borderColor: '#B3B3B3', mb: 2 }} />
                        {/* <Box
                        >
                            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 0.5 }}>Total Price</Typography>
                            <Box sx={{ mb: 1 }}>
                                {(
                                    (location?.state?.stripePricingList?.length > 0) ||
                                    (location?.state?.stripe_pricing_list?.length > 0)
                                ) && (
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                color: 'text.secondary',
                                                textDecoration: 'line-through',
                                                display: 'inline-block',
                                                mr: 1,
                                            }}
                                        >
                                            {(() => {
                                                const priceList =
                                                    location?.state?.stripePricingList || location?.state?.stripe_pricing_list;
 
                                                const rawValue = priceList?.[0]?.value;
                                                const price = Number(rawValue) || 0;
 
                                                return `$${(price + price * 1.6).toFixed(2)}`;
                                            })()}
                                        </Typography>
 
                                    )}
 
                                <Typography
                                    variant="h5"
                                    component="p"
                                    sx={{
                                        fontWeight: 'bold',
                                        display: 'inline-block',
                                        color: '#252525',
                                    }}
                                >
                                    {(() => {
                                        const priceList =
                                            location?.state?.stripePricingList || location?.state?.stripe_pricing_list;
                                        const rawValue = priceList?.[0]?.value;
                                        const price = Number(rawValue) || 0;
                                        return `$ ${price.toFixed(2)}`;
                                    })()}
                                </Typography>
                            </Box>
                            <Typography variant="body2" sx={{ fontSize: '12px', fontWeight: 'bold' }}>Valid For:
                                <Typography component="span" sx={{ fontSize: '12px !important' }}>30 Days</Typography></Typography>
                            <Typography variant="body2" sx={{ fontSize: '12px', fontWeight: 'bold' }}>Auto Renewal:
                                <Typography component="span" sx={{ fontSize: '12px !important' }}>On</Typography></Typography>
                        </Box> */}
 
                        <Box>
                            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 0.5 }}>
                                Total Price
                            </Typography>
 
                            <Box sx={{ mb: 1 }}>
                                {(() => {
                                    const priceList =
                                        location?.state?.stripePricingList ||
                                        location?.state?.stripe_pricing_list ||
                                        [];
 
                                    if (!priceList.length) return null;
                                    const selectedPrice =
                                        priceList.find(item => item?.related_currency_type_lk === 2) ||
                                        priceList[0];
 
                                    const price = Number(selectedPrice?.value) || 0;
                                    const originalPrice = price + price * 1.6;
 
                                    return (
                                        <>
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    color: 'text.secondary',
                                                    textDecoration: 'line-through',
                                                    display: 'inline-block',
                                                    mr: 1,
                                                }}
                                            >
                                                ${originalPrice.toFixed(2)}
                                            </Typography>
 
                                            <Typography
                                                variant="h5"
                                                component="p"
                                                sx={{
                                                    fontWeight: 'bold',
                                                    display: 'inline-block',
                                                    color: '#252525',
                                                }}
                                            >
                                                $ {price.toFixed(2)}
                                            </Typography>
                                        </>
                                    );
                                })()}
                            </Box>
 
                            <Typography variant="body2" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                Valid For:
                                <Typography component="span" sx={{ fontSize: '12px !important' }}>
                                    30 Days
                                </Typography>
                            </Typography>
 
                            <Typography variant="body2" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                Auto Renewal:
                                <Typography component="span" sx={{ fontSize: '12px !important' }}>
                                    On
                                </Typography>
                            </Typography>
                        </Box>
 
 
                        <Box
                            sx={{
                                bgcolor: COLORS.includedBg,
                                borderRadius: '8px',
                                pb: '10px', margin: '8px 0'
                            }}
                        >
                            <Typography variant="subtitle1" component="p" sx={{ fontSize: '12px', fontWeight: 'bold', mb: 0.5, color: COLORS.includedText, padding: '10px 10px 5px 10px' }}>
                                This Assessment plan includes:
                            </Typography>
                            <Box
                                sx={{ padding: '0px 10px 10px 0 !important', }}>
                                <Box component="ul" sx={{ listStyleType: 'disc', listStylePosition: 'inside', paddingLeft: '5px' }}>
                                    {INCLUDED_ITEMS.map((text, index) => (
                                        <Typography key={index} component="li" variant="body2" sx={{ color: COLORS.includedText, mb: 0.5, fontSize: '12px', lineHeight: 1.6, pl: '20px' }}>
                                            {text}
                                        </Typography>
                                    ))}
                                </Box>
                            </Box>
                        </Box>
 
 
                        <Button variant="contained" fullWidth size="large" onClick={postAssessmentSubscribtionDetails}
                            sx={{ fontWeight: 'bold', py: 1, mt: 1, borderRadius: '3px', bgcolor: COLORS.primary, '&:hover': { bgcolor: COLORS.primary } }}>
                            Pay Now
                        </Button>
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    }
 
    return (
        <>
            {location.state?.subscriptionplanid || location.state?.subscriptionPlanId ?
                <Prepayment /> :
                <ComingSoon />}
        </>
    );
};
 
export default CheckoutPage;
 
 
 
 